import styled from 'styled-components'

export const LabelContainer = styled.span`
  display: flex;
  font-family: ${({ theme }) => theme.fonts.mainFont};
  justify-content: space-between;
`

export const Duration = styled.span`
  align-items: center;
  display: inline-flex;
  font-family: ${({ theme }) => theme.fonts.mainFont};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 17px;
  margin-left: auto;
`
